import React from "react";
import { Chart } from "react-google-charts";




  
  
export const options = {
  title: "All items and Total summary",
  chartArea: { width: "50%" },
  hAxis: {
    title: "Total Quantity",
    minValue: 0,
  },
  vAxis: {
    title: "Items",
  },
};

const PieChart = ({Admin,Car,Brands,Category}) => {
  const data = [
    ["Items", "Number"],
    ["Admin", Admin],
    ["Total Cars", Car],
    ["Total Brands", Brands],
    ["Total Category", Category ]
  ];
  return (
    <div className="w-[100%] lg:w-[49%] bg-white hover:scale-105 transition duration-300 shadow-xl rounded-lg">
    <Chart
    chartType="BarChart"
    width="100%"
    height="400px"
    data={data}
    options={options}
  />
  </div>
  )
}

export default PieChart
